import React from 'react';
const ZIndexContext = /*#__PURE__*/React.createContext(undefined);
if (process.env.NODE_ENV !== 'production') {
  ZIndexContext.displayName = 'ZIndexContext';
}
export default ZIndexContext;